export const lang =
  localStorage.getItem("lang") || navigator.language.slice(0, 2);
localStorage.setItem("lang", lang);
document.documentElement.setAttribute("lang", lang);
export const defaultCurr = () => localStorage.getItem("defaultCurr");

export const newPerson: any = {
  merchantName: "",
  merchantUsername: "",
  logo: "",
  phone: "",
  country: 0,
  city: 0,
  BCode: 0,
  startTsn: 1,
  terminalsCount: 1,
  status: { label: "Active", value: "Active" },
  merchantCode: "",
  currency: 0,
  email: "",
  partner: null,
  errors: {},
  legalForm: "",
  address: "",
  registrationNumber: "",
  fiscalId: "",
  representative: "",
  showAdditionalFields: false,
};
export const newCurrency: any = {
  currencyCode: "",
  currencyShortName: "",
  currencyFullName: "",
  country: "",
  errors: {},
};

export const newUser: any = {
  name: "",
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  role: "",
  status: "",
  outletId: "",
  errors: {},
};

export const newTerminal: any = {
  merchantId: "",
  onBoardingStatus: false,
  Tsn: "",
  terminalId: "",
  hardwareSerialNumber: "",
  errors: {},
};
export const terminalDetails: any = {
  terminalId: "",
  merchantId: "",
  terminalCode: "",
  terminalSerialNumber: "",
  outletId: "",
  ksn: "",
  deviceId: "",
  terminalLatitude: 0,
  terminalLongitude: 0,
  //createdDate:2023-04-02 21:18:12.348,
  outletName: "",
  deviceModel: "",
  terminalStatus: false,
  errors: {},
};

export const newOutlet: any = {
  name: "",
  code: "",
  address: "",
  latitude: "",
  longitude: "",
  errors: {},
};

export const newInputs: any = {
  input1: "",
  input2: "",
  input3: "",
  input4: "",
  input5: "",
  input6: "",
};

export const newInputChangePassword: any = {
  password: "",
  confirmPassword: "",
  errors: {},
};
export const newPasswordReset: any = {
  currentPassword: "",
  password: "",
  confirmPassword: "",
  errors: {},
};

export interface Terminal {
  deviceId: string;
  ksn: string;
  merchantId: string;
  outletId: string;
  terminalCode: string;
  deviceModel: string;
  terminalId: string;
  terminalLatitude: number;
  terminalLongitude: number;
  terminalSerialNumber: string;
  outletName: string;
  terminalStatus: boolean | any;
}

export interface AvailableTerminal {
  terminalSerialNumber: string;
  onBoardingStatus: boolean;
  timestamp: number;
}

export interface TerminalSummary {
  terminalCode: string;
  imeiCode: string;
  outlet: string;
  latestTransactionTimestamp: string;
  tsn: string;
  terminalLatitude: string;
  terminalLongitude: string;
}

export interface Outlet {
  address: string;
  code: string;
  latitude: number;
  longitude: number;
  name: string;
  outletId: string;
}

export interface User {
  email: string;
  firstName: string;
  userId: string;
  lastName: string;
  outletId: string;
  phoneNumber: string;
  role: string;
  status: string;
  username: string;
  createdDate: string;
  keycloakUserId: string;
}

export interface OutletSummary {
  name: string;
  outletCode: string;
  merchantName: string;
  outletAddress: string;
  operations: number;
  operationsValue: string;
  activatedAssignedUsers: number;
  terminals: number;
}

export interface Transaction {
  trxId: string;
  trxTimestamp: string;
  amount: number;
  cardType: string;
  cardSequenceNumber: string;
  tsn: string;
  merchantId: string;
  terminalId: string | null;
  loggedUserId: string;
  status: string;
  operationType: string;
  cardNumber: string;
}

export type TabActiveState = {
  name: string;
};
export interface getTabProps {
  setActiveLink?: React.Dispatch<React.SetStateAction<string>>;
  setShowDetailsTab?: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface EInvoiceListItem {
  invoiceId: string;
  customer: any;
  products: [];
  summary: any;
}
export interface EInvoiceList {
  merchantId: string;
  Invoices: EInvoiceListItem[];
}

export interface InvoiceSummary {
  invoiceId: string;
  createdDate: string;
  discount: string;
  encodedStringForQrcode: string;
  invoiceStatus: string;
  invoiceTotal: string;
  modifiedDate: string;
  paymentLink: string;
  sendBy: string;
  shippingPrice: string;
  subTotal: string;
  taxValue: string;
  totalItem: string;
  totalWithoutTax: string;
  products: any[];
  customer: any;
}

export interface Reconciliation {
  trxId: string;
  tsn: string;
  trxTimestamp: string;
  totalAmount: number;
  terminalId: string;
  status: string;
}

export interface ReconciliationSummary {
  id: number;
  debit_count: number;
  debit_amount: number;
  credit_count: number;
  credit_amount: number;
  naqd: number;
  cash_advance: number;
  auth: number;
  total_count: number;
  total_amount: number;
  terminal_type: string;
  scheme_id: string;
}

export interface ReconciliaionDetails {
  id: number;
  purchase_offline_count: number;
  purchase_offline_amount: number;
  purchase_online_count: number;
  purchase_online_amount: number;
  purchase_naqd_count: number;
  purchase_naqd_amount: number;
  reversal_count: number;
  reversal_amount: number;
  refund_count: number;
  refund_amount: number;
  completed_count: number;
  completed_amount: number;
  scheme_id: string;
}

export interface Scheme {
  /* scheme_id: string,
  host: {
    id: number,
    debit_count: number,
    debit_amount: number,
    credit_count: number,
    credit_amount: number,
    naqd: number,
    cash_advance: number,
    auth: number,
    total_count: number,
    total_amount: number,
    terminal_type: string,
    scheme_id: string
  },
  terminal: {
    id: number,
    debit_count: number,
    debit_amount: number,
    credit_count: number,
    credit_amount: number,
    naqd: number,
    cash_advance: number,
    auth: number,
    total_count: number,
    total_amount: number,
    terminal_type: string,
    scheme_id: string
  },
  terminal_detail: {
    id: number,
    purchase_offline_count: number,
    purchase_offline_amount: number,
    purchase_online_count: number,
    purchase_online_amount: number,
    purchase_naqd_count: number,
    purchase_naqd_amount: number,
    reversal_count: number,
    reversal_amount: number,
    refund_count: number,
    refund_amount: number,
    completed_count: number,
    completed_amount: number,
    scheme_id: string
  },  */

  reconciliationSummary: ReconciliationSummary[];
  reconciliationDetail: ReconciliaionDetails[];
  matched: string;
  rc_date: string;
  requested_by: string;
  terminal_id: string;
  merchant_id: string;
  id: number;
}

export interface ReconciliactionHistory {
  rc_status: RC_Status;
  schemes: Scheme[];
}

export interface RC_Status {
  id: number;
  matched: string;
  rc_date: string;
  requested_by: string;
  terminal_id: string;
}

export interface HostAndTerminal {
  auth: number;
  cash_advance: number;
  credit_amount: number;
  credit_count: number;
  debit_amount: number;
  debit_count: number;
  id: number;
  naqd: number;
  scheme_id: string;
  terminal_type: string;
  total_amount: number;
  total_count: number;
}

export interface TerminalDetails {
  completed_amount: number;
  completed_count: number;
  id: number;
  purchase_naqd_amount: number;
  purchase_naqd_count: number;
  purchase_offline_amount: number;
  purchase_offline_count: number;
  purchase_online_amount: number;
  purchase_online_count: number;
  refund_amount: number;
  refund_count: number;
  reversal_amount: number;
  reversal_count: number;
  scheme_id: string;
}
export interface ReciptScheme {
  scheme_id: string;
  host: {
    auth: number;
    cash_advance: number;
    credit_amount: number;
    credit_count: number;
    debit_amount: number;
    debit_count: number;
    id: number;
    naqd: number;
    scheme_id: string;
    terminal_type: string;
    total_amount: number;
    total_count: number;
  };
  terminal: {
    auth: number;
    cash_advance: number;
    credit_amount: number;
    credit_count: number;
    debit_amount: number;
    debit_count: number;
    id: number;
    naqd: number;
    scheme_id: string;
    terminal_type: string;
    total_amount: number;
    total_count: number;
  };
  terminal_detail: {
    completed_amount: number;
    completed_count: number;
    id: number;
    purchase_naqd_amount: number;
    purchase_naqd_count: number;
    purchase_offline_amount: number;
    purchase_offline_count: number;
    purchase_online_amount: number;
    purchase_online_count: number;
    refund_amount: number;
    refund_count: number;
    reversal_amount: number;
    reversal_count: number;
    scheme_id: string;
  };
}
export interface MerchantEx {
  merchantId: string;
  merchantName: string;
  email: string;
  merchantCode: string;
  isDeleted: string;
  city: any | number;
  country: any | number;
  businessCategoryCode: number;
  currencyCode: number;
  logo: string | null;
  registeredMobileNumber: string;
  startTsn: string;
  terminalsCount: number;
  status: string;
  businessCategoryId: number;
  businessCategoryName: string;
  businessCategory: any;
  createdDate: number;
  lastModifiedDate: number;
  integrationType?: string;
  recurringEnabled?: boolean;
  payByLinkEnabled?: boolean;
  checkoutEnabled?: boolean;
  softPosEnabled?: boolean;
  paymentGatewayEnabled?: boolean;
  invoicingEnabled?: boolean;
}

export interface newTerminal {
  merchantId: string;
  onBoardingStatus: boolean;
  Tsn: string;
}

export const apiError = (
  loadingType: string,
  faildType: string,
  err: any,
  dispatch: any,
  request?: string
) => {
  dispatch({ type: loadingType, loading: false });

  if (err.response) {
    if (err.response.data.message) {
      dispatch({
        type: faildType,
        error: err.response.data.message,
        request,
      });
    } else {
      dispatch({
        type: faildType,
        error: "Something error !! Please contact the technical administrator.",
        request,
      });
    }
  } else if (err.request) {
    dispatch({
      type: faildType,
      error: err.request.message,
      request,
    });
  } else {
    dispatch({
      type: faildType,
      error: "Something error !! Please contact the technical administrator.",
      request,
    });
  }
};

export interface TmsDataType {
  type_id: string;
  type_name: string;
  type_description: string;
}

export interface CreateInvoiceData {
  invoiceId: number;
  name: string;
  email: string;
  phoneNum: string | any;
  address: string;
  language: string | any;
  vatId: string;
  productId: string;
  productName: string;
  productDiscount: number;
  pricePerUnit: number;
  quanttiy: number;
  totalPrice: number;
  shipingPrice: number;
  sendBy: string | any;
  totalItem: number;
  subTotal: number;
  discount: number;
  totalWithoutTax: number;
  taxValue: number;
  invoiceTotal: number;
  description: string;
  customerType?: string;
  accountNumber?: string;
  bankName?: string;
  nationalId?: string;
  nationalIdIssueDate?: string;
  nationalIdIssuePlace?: string;
  legalForm?: string;
  capitalAmount?: number;
  registrationNumber?: string;
  fiscalId?: string;
}

export interface invoiceProduct {
  productId: number | any;
  productName: string;
  pricePerUnit: number;
  productDiscount: number;
  quanttiy: number;
  totalPrice: number;
}

export interface MerchantPaymentConfiguration {
  expesspayMerchantId: string;
  merchantKey: string;
  merchantTestKey: string;
  passwordKey: string;
  merchantVatId: string;
}

export interface RetailerData {
  id: string;
  terminal_id: string;
  next_load: string;
  reconciliation_time: string;
  retailer_Number_English: string;
  retailer_Name_English: string;
  retailer_Name_Arabic: string;
  retailer_Language_Indicator: string;
  terminal_Country_Code: string;
  terminal_Currency_Code: string;
  transaction_Currency_Exponent: string;
  currency_Symbol_Arabic: string;
  currency_Symbol_English: string;
  arabic_Receipt_1: string;
  arabic_Receipt_2: string;
  english_Receipt_1: string;
  english_Receipt_2: string;
  retailer_Address1_Arabic: string;
  retailer_Address1_English: string;
  terminal_Capability: string;
  additional_Terminal_Capabilities: string;
  download_Phone_Number: string;
  emv_Terminal_Type: string;
  automatic_Load: string;
  saf_Retry_Limit: string;
  saf_Default_Message_Transmission_Number: string;
}

export interface TMSCardScheme {
  schema_id: string;
  card_scheme_id: string;
  card_scheme_name_ar: string;
  card_scheme_name_en: string;
  card_scheme_aquire_id: string;
  merchant_category_code: string;
  merchant_id: string;
  terminal_id: string;
  check_service_code: string;
  offline_refund_indicator: string;
  transaction_allowed: string;
  cardholder_authentication: string;
  supervisor_functions: string;
  manual_entry_allowed: string;
  floor_limit_ind: string;
  terminal_floor_limit: string;
  terminal_floor_limit_fallback: string;
  maximum_cashback: string;
  max_trx_amount_ind: string;
  max_amount: string;
  luhan_check: string;
  expiry_date_position: string;
  card_ranges: string;
  card_prefix_sequence_ind: string;
  enable_EMV: string;
  delay_call_setup: string;
}

export interface PaymentGateway {
  payment_public_id: string;
  merchant_order_id: string;
  merchant: string;
  mid: string;
  transaction_date: string;
  type: string;
  status: string;
  description: string;
  ammount: string;
  currency: string;
}

export interface RecieptDetails {
  mti: string;
  pan: string;
  stan: string;
  rnn: string;
  requestId: string;
  trxTimestamp: string;
  isoMsg: string;
  MTI: string;
  PAN: string;
  processingCode: string;
  cardType: string;
  transactionAmount: string;
  transmissionDateAndTime: string;
  STAN: string;
  cardExpirationDate: string;
  localTransactionDateAndTime: string;
  pointOfServiceCode: string;
  functionCode: string;
  RNN: string;
  cardAcceptorTerminalIdentification: string;
  cardAcceptorIdentificationCode: string;
  currencyCodeOfTransaction: string;
  coordinates: string;
  messageAuthenticationCodeField: string;
  receiveTime: string;
  additionalDataNational: string;
  acquirerInstitutionIdentificationCode: string;
  cardAcceptorBusinessCode: string;
  reconciliationDate: string;
  approvalCode: string;
  actionCode: string;
  securityRelatedControlInformation: string;
  privateTerminalStatus: string;
  cardSchemeID: string;
  cardSchemeSponsorID: string;
  cardAcceptorNameLocation: null;
  currencyCodeOfReconciliation: null;
  canRefund: boolean;
  canCancel: boolean;
  terminalID: string;
  track2Data: string;
  cardSequenceNumber: string;
  iccRelatedData: string;
  tsn: string;
  createdBy: string;
  apkVersionNo: string;
  applicationId: string;
  kernelId: string;
  applicationCryptogram: string;
  cryptogramInformationData: string;
  madaMerchantId: string;
  madaTerminalId: string;
  acquirerBank: string;
  tvr: string;
  cvm: string;
  transactionStatusInfo: string;
  cardholderName: string;
  status: string;
}

export interface dateRange {
  startDate: string;
  endDate: string;
}

export interface FilterTransactionDetails {
  terminalId: string;
  tsn: string;
  RRN: string;
  operationType: any[];
  transactionType: any[];
  amountFrom: string;
  amountTo: string;
  cardType: any[];
  transactionStatus: any[];
  ReconcilationStatus: any[];
  startDate: string;
  endDate: string;
  merchantId?: string;
  loggerUserId: string;
  outletId: string;
  pageSize: string | number;
  sortBy: string;
  sortDirection: string;
  pageNumber: string;
}

export interface FilterInvoicesDetails {
  merchantId?: string;
  invoiceId: string;
  startDate: string;
  endDate: string;
  invoiceTotalFrom: string;
  invoiceTotalTo: string;
  invoiceStatus: any[];
  name: string;
  email: string;
  vatId: string;
  address: string;
  phoneNum: string;
  pageSize: string;
  sortBy: string;
  sortDirection: string;
  pageNumber: string;
  partnerId: string | null;
}

export interface FilterReconciliationDetails {
  merchantId?: string;
  id: string;
  startDate: string;
  endDate: string;
  reconciliationStatus: any[];
  terminalId: any[] | any;
  requestedBy: any[];
  pageSize: string;
  sortBy: string;
  sortDirection: string;
  pageNumber: string;
}

export interface ReconciliationList {
  id: number;
  reconciliationSummary: any[];
  reconciliationDetail: any[];
  matched: string;
  rc_date: string;
  requested_by: string;
  terminal_id: string;
  merchant_id: string;
}
